import { useEffect, useState } from "react";
import Shell from "../components/Shell";
import { fetchNotifications } from "../lib/api";
import { PriorityBadge } from "../components/ui-bits";

function fmt(ts) {
  if (!ts) return "—";
  try {
    return new Date(ts).toLocaleString();
  } catch {
    return ts;
  }
}

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const data = await fetchNotifications();
        if (active) setItems(data);
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    const t = setInterval(load, 6000);
    return () => {
      active = false;
      clearInterval(t);
    };
  }, []);

  return (
    <Shell title="Alerts log" subtitle="Every Telegram notification sent (or failed) is recorded here.">
      <div className="border border-zinc-200 bg-white overflow-x-auto">
        <div className="hidden md:grid grid-cols-12 px-6 py-3 bg-zinc-50 border-b border-zinc-200 overline">
          <div className="col-span-3">Time</div>
          <div className="col-span-4">Group</div>
          <div className="col-span-2">Priority</div>
          <div className="col-span-2">Status</div>
          <div className="col-span-1 text-right">—</div>
        </div>
        {loading && <div className="p-10 text-center text-sm text-zinc-400">Loading…</div>}
        {!loading && items.length === 0 && (
          <div className="p-10 text-center text-sm text-zinc-400">No notifications yet.</div>
        )}
        {items.map((n) => (
          <div
            key={n.id}
            data-testid={`notif-row-${n.id}`}
            className="grid grid-cols-2 md:grid-cols-12 px-4 sm:px-6 py-3 border-b border-zinc-100 last:border-b-0 hover:bg-zinc-50 items-center text-sm gap-2"
          >
            <div className="col-span-2 md:col-span-3 font-mono-num text-xs text-zinc-600">{fmt(n.sent_at)}</div>
            <div className="md:col-span-4 truncate">{n.group_name}</div>
            <div className="md:col-span-2">
              <PriorityBadge priority={n.priority} />
            </div>
            <div className="md:col-span-2">
              {n.status === "sent" ? (
                <span className="text-emerald-600 text-xs font-medium">SENT</span>
              ) : (
                <span className="text-[#FF3B30] text-xs font-medium" title={n.error}>
                  FAILED
                </span>
              )}
            </div>
            <div className="md:col-span-1 text-right text-[10px] text-zinc-400 truncate">
              {n.error ? n.error.slice(0, 30) : ""}
            </div>
          </div>
        ))}
      </div>
    </Shell>
  );
}
